import {
  Box,
  Container,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import React from 'react';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3),
    paddingTop: 80,
    paddingBottom: 80
  },
  image: {
    maxWidth: '100%',
    width: 520,
    maxHeight: 280,
    height: 'auto'
  }
}));

function MaintenanceView() {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page className={classes.root} title="Mantenimiento">
      <Container maxWidth="lg">
        <Typography
          align="center"
          variant={mobileDevice ? 'h4' : 'h1'}
          color="textPrimary"
        >
          Estamos en mantenimiento
        </Typography>
        <Typography align="center" variant="subtitle2" color="textSecondary">
          Estamos realizando tareas de mantenimiento. Vuelve a intentarlo en
          unos minutos.
        </Typography>
        <Box mt={6} display="flex" justifyContent="center">
          <img
            alt="Maintenance"
            className={classes.image}
            src="/static/images/undraw_add_file2_gvbb.svg"
          />
        </Box>
      </Container>
    </Page>
  );
}

export default MaintenanceView;
